import { mutativeMethods } from './mutativeMethods';
import { Store } from '@core';
import { autobind } from '@lib/autobind';

type MutativeMethods = typeof mutativeMethods;

declare module '..' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<T> extends MutativeMethods {}
}

Object.assign(Store.prototype, mutativeMethods);
autobind(Store);
